import {
	TEST_ELEMENT_IDS,
	UIElementIdentifier,
} from '@dealstack/frontend/shared/helper/UIElementIdentifier/UIElementIdentifier';
import {
	Alert,
	AlertDescription,
	AlertTitle,
} from '@dealstack/frontend/shared/components/Alert/Alert';
import { Button as ButtonV2 } from '@dealstack/frontend/shared/components/fundament/Button/Button.v2';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { useEffect, useState } from 'react';
import styled from 'styled-components';

const INITIAL_SECOND = 10;
const useCountdown = (callback: () => void) => {
	const [seconds, setSeconds] = useState(INITIAL_SECOND);
	useEffect(() => {
		const countdownInterval = setInterval(() => {
			if (seconds > 0) {
				setSeconds((prevSeconds) => prevSeconds - 1);
			} else {
				callback();
				clearInterval(countdownInterval);
			}
		}, 1000);

		return () => {
			clearInterval(countdownInterval);
		};
	}, [seconds]);
	return seconds >= 0 ? seconds : null;
};

interface Props {
	onCancel: () => void;
	onSubmit: () => void;
	title: string;
	description: string;
	disabledSubmitButton?: boolean;
}

export const ConfirmationModalV2 = ({
	onCancel,
	onSubmit,
	description,
	title,
	disabledSubmitButton,
}: Props) => {
	const tMipManage = useTranslationMipManage();

	const seconds = useCountdown(onSubmit);
	return (
		<Alert icon="tick-circle-filled" state="success" size="s">
			<AlertTitle>{title}</AlertTitle>
			<AlertDescription>{description}</AlertDescription>
			<AlertButtonWrapper>
				<UIElementIdentifier
					identifier={TEST_ELEMENT_IDS.MIP_MANAGE_SEND_INVITATION_MODAL_CONFIRM}
				>
					<ButtonV2
						size="s"
						icon="close-v3"
						buttonTheme="light"
						variant="secondary"
						onClick={onSubmit}
						disabled={disabledSubmitButton}
					>
						{tMipManage('invitation_modal.confirmation_alert_button')}
					</ButtonV2>
				</UIElementIdentifier>
				{!!seconds && (
					<ButtonV2
						size="s"
						icon="close-v3"
						buttonTheme="light"
						variant="ghost"
						onClick={onCancel}
						data-testid={TEST_ELEMENT_IDS.MIP_MANAGE_SEND_INVITATION_MODAL_UNDO}
					>
						{tMipManage('invitation_modal.undo', {
							second: seconds,
						})}
					</ButtonV2>
				)}
			</AlertButtonWrapper>
		</Alert>
	);
};

const AlertButtonWrapper = styled.div`
	display: flex;
	gap: 0.5rem;
`;
